import * as actionTypes from 'containers/Campaigns/CreateEdit/store/action-types';
import { CampaignObjectiveKeyType } from 'utils/types';
import { CampaignUpdateActionContext, CampaignUpdateActionContextType } from 'utils/campaigns';
import { ProductSelection } from 'components/ProductsSelection/types';
import { SelectionItemType } from 'components/FilterModal/types';

export type SelectionType = {
  applied: SelectionItemType;
};

export type DetailsType = {
  name: string;
  storeGroupName: string;
  itemGroupName: string;
  objective: CampaignObjectiveKeyType;
  startDate: string;
  endDate: string;
  notes: string;
};

export type StateType = {
  readonly campaignId: string;
  readonly context: CampaignUpdateActionContextType;
  readonly currentStep: number; // 1 stores, 2 items, 3 details, 4 create confirmation
  readonly details: DetailsType;
  readonly show: boolean;
  readonly savingError: string;
  readonly selection: ProductSelection;
};

export const initialState: StateType = {
  campaignId: null,
  context: CampaignUpdateActionContext.CAMPAIGNS,
  currentStep: 1,
  details: {
    name: '',
    storeGroupName: '',
    itemGroupName: '',
    objective: null,
    startDate: '',
    endDate: '',
    notes: '',
  },
  show: false,
  savingError: null,
  selection: {
    accounts: [],
    items: [],
    states: [],
    stores: [],
  },
};

const addLabelToItem = (item) => ({
  id: item,
  label: item,
});

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.CAMPAIGN_SET:
      return {
        ...state,
        details: {
          name: action.payload.name,
          storeGroupName: action.payload.storeGroupName,
          itemGroupName: action.payload.itemGroupName,
          objective: action.payload.objective,
          startDate: action.payload.startDate,
          endDate: action.payload.endDate !== null ? action.payload.endDate : '',
          notes: action.payload.notes !== null ? action.payload.notes : '',
        },
        selection: {
          accounts: action.payload.storeFilters.accounts.map(addLabelToItem),
          states: action.payload.storeFilters.states.map(addLabelToItem),
          stores: action.payload.storeFilters.stores.map(addLabelToItem),
          items: action.payload.itemFilters.items.map(addLabelToItem),
        },
      };
    case actionTypes.CREATE_CAMPAIGN_MODAL_OPEN:
      return {
        ...state,
        campaignId: null,
        currentStep: 1,
        show: true,
        details: { ...initialState.details },
        savingError: null,
        selection: { ...initialState.selection },
      };
    case actionTypes.CURRENT_STEP_SET:
      return {
        ...state,
        currentStep: action.payload,
      };
    case actionTypes.DETAILS_VALUE_CHANGE:
      return {
        ...state,
        details: {
          ...state.details,
          [action.payload.attribute]: action.payload.value,
        },
      };
    case actionTypes.EDIT_CAMPAIGN_MODAL_OPEN:
      return {
        ...state,
        campaignId: action.payload.id,
        context: action.payload.context,
        currentStep: 1,
        details: { ...state.details },
        show: true,
        savingError: null,
      };
    case actionTypes.SHOW_SET:
      return {
        ...state,
        show: action.payload,
      };
    case actionTypes.PREVIOUS:
      return {
        ...state,
        currentStep: action.payload,
        savingError: null,
      };
    case actionTypes.SAVING_ERROR_SET:
      return {
        ...state,
        savingError: action.payload,
      };
    case actionTypes.RESET:
      return {
        ...state,
        campaignId: null,
        details: {
          ...state.details,
          name: initialState.details.name,
        },
        selection: { ...initialState.selection },
      };
    default:
      return state;
  }
};

export default reducer;
